import api from './index';

const UserServices = {
  // Buscar perfil do usuário
  getProfile: async () => {
    try {
      console.log('UserServices - Buscando perfil do usuário...');
      const response = await api.get('/api/user/profile');
      console.log('UserServices - Perfil obtido:', response.data);
      return response.data;
    } catch (error) {
      console.error('UserServices - Erro ao buscar perfil:', error);
      throw new Error(error.response?.data?.message || 'Erro ao buscar perfil');
    }
  },

  // Atualizar perfil do usuário
  updateProfile: async (userData) => {
    try {
      console.log('UserServices - Atualizando perfil:', userData);
      const response = await api.put('/api/user/profile', userData);
      console.log('UserServices - Perfil atualizado:', response.data);
      return response.data;
    } catch (error) {
      console.error('UserServices - Erro ao atualizar perfil:', error);
      throw new Error(error.response?.data?.message || 'Erro ao atualizar perfil');
    }
  },

  // Alterar senha do usuário
  changePassword: async (passwordData) => {
    try {
      console.log('UserServices - Alterando senha...');
      const response = await api.put('/api/user/change-password', passwordData);
      console.log('UserServices - Senha alterada:', response.data);
      return response.data;
    } catch (error) {
      console.error('UserServices - Erro ao alterar senha:', error);
      throw new Error(error.response?.data?.message || 'Erro ao alterar senha');
    }
  }
};

export default UserServices;


